import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import GuideButton from "./GuideButton";
import PassMenuList from "./PassMenuList";
import PassSelectButton from "./PassSelectButton";
import PurchaseCTA from "./PurchaseCTA";
import { TabFormSection } from "./PurchaseLayouts";
import PurchaseOption from "./PurchaseOption";
import { usePassSelect } from "./usePassSelect";
const PassUsageTab = (param)=>{
    let { passes , onClick , fullWidth  } = param;
    const { anchorEl , menuWidth , menuListOpen , selectedPass , handleSelectClick , handleSelectClose , handlePassSelect  } = usePassSelect(passes, fullWidth);
    var _selectedPass_id;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(TabFormSection, {
                sx: {
                    py: 2.5
                },
                title: "이용권 선택",
                children: [
                    /*#__PURE__*/ _jsx(PassSelectButton, {
                        open: menuListOpen,
                        onClick: handleSelectClick,
                        pass: selectedPass
                    }),
                    /*#__PURE__*/ _jsx(PassMenuList, {
                        anchorEl: anchorEl,
                        onClose: handleSelectClose,
                        open: menuListOpen,
                        menuWidth: menuWidth,
                        passes: passes,
                        onPassSelect: handlePassSelect,
                        selectedId: (_selectedPass_id = selectedPass === null || selectedPass === void 0 ? void 0 : selectedPass.id) !== null && _selectedPass_id !== void 0 ? _selectedPass_id : null
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(TabFormSection, {
                sx: {
                    pb: 2.5
                },
                title: "구매옵션 선택",
                children: [
                    /*#__PURE__*/ _jsx(Stack, {
                        direction: "row",
                        spacing: 1,
                        children: /*#__PURE__*/ _jsx(PurchaseOption, {})
                    }),
                    /*#__PURE__*/ _jsx(GuideButton, {})
                ]
            }),
            /*#__PURE__*/ _jsx(PurchaseCTA, {
                variant: "basicpass",
                onClick: onClick
            })
        ]
    });
};
export default PassUsageTab;
